import { SliderInitialState, SliderProps, ReduxAction } from '../models'
import { SliderTypes } from '../types'

export const SliderState = (
  state: SliderProps[] = SliderInitialState,
  action?: ReduxAction
): SliderProps[] => {
  if (!action) return state

  switch (action.type) {
    case SliderTypes.SET_SLIDER_DATA:
      return action.payload
  }

  return state
}

